import { Routes } from '@angular/router';
import {HomepageComponent} from './components/homepage/homepage.component';
import {NotFoundPageComponent} from './components/not-found-page/not-found-page.component';
import {FeedbackComponent} from './components/feedback/feedback.component';

export const routes: Routes = [
  {
    path: '',
    component: HomepageComponent,
  },
  {
    path: 'feedback',
    component: FeedbackComponent,
  },
  {
    path: '**',
    component: NotFoundPageComponent
  }
];
